import { useState, type FC } from "react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { Activity } from "lucide-react";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const MainReasonWeightLoss: FC = () => {
  const navigate = useNavigate();
  const [selectedReason, setSelectedReason] = useState<string>("");

  const handleNext = () => {
    // Save weight loss reason to session storage
    SessionStorageHelper.saveField("weight_loss_reasons", selectedReason);

    // Navigate to the next assessment page
    navigate("/glucera" + GluceraNavigationRoutes.DIETPAGE);
  };

  const reasons = [
    "To improve blood sugar / manage diabetes",
    "Doctor recommended it",
    "General health / feel better",
    "To look or feel more confident",
    "Other",
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 p-4">
          {/* Logo */}
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-orange-400">
              <Activity className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-500">
              Bite Balance
            </span>
          </div>

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 7 of 12
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-6 py-2">
          <div className="mb-4 space-y-2">
            <h1 className="text-xl font-bold text-foreground sm:text-2xl">
              What's Your Main Reason For Trying To Lose Weight?
            </h1>
            <p className="text-sm text-muted-foreground">
              The answer on the previous screen is Yes
            </p>
          </div>

          <div className="mb-4 flex-1 space-y-3 overflow-y-auto">
            {reasons.map(reason => (
              <Card
                key={reason}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selectedReason === reason
                    ? "border-2 border-primary bg-primary/5"
                    : "border-2 border-border hover:border-primary/50"
                }`}
                onClick={() => setSelectedReason(reason)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-lg font-semibold">{reason}</span>
                  <div
                    className={`flex h-6 w-6 items-center justify-center rounded-full border-2 ${
                      selectedReason === reason
                        ? "border-primary bg-primary"
                        : "border-muted-foreground"
                    }`}
                  >
                    {selectedReason === reason && (
                      <div className="h-3 w-3 rounded-full bg-primary-foreground" />
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container */}
          <div className="mt-auto pt-4">
            <Button
              onClick={handleNext}
              disabled={!selectedReason}
              className="h-11 w-full rounded-xl bg-gradient-primary text-sm hover:opacity-90 disabled:opacity-50 sm:h-12 sm:text-base"
            >
              Next
            </Button>
          </div>
        </div>

        {/* Safe area padding */}
        <div className="pb-safe p-2" />
      </div>
    </div>
  );
};

export default MainReasonWeightLoss;
